module.exports = __webpack_public_path__ + "static/media/FREE_DELIVERY_60X50.bb98b9a7.svg";